import { Box } from '@mui/material';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import NotFound from '../../default/components/not-found';
import {
  ALL_PROJECTS,
  ALL_RESOURCE_ALLOCATIONS,
  DASHBOARD,
  HOME_ROUTE,
  NOTIFICATIONS,
  NOT_FOUND,
  PENDING_ACTIONS,
  PROJECTS,
  RESOURCE_ALLOCATIONS,
  SINGLE_PROJECT,
  SINGLE_RESOURCE_ALLOCATIONS,
  TOOLS_AND_TECHNOLOGIES,
  USERS
} from '../utils/routes';
import Sidebar from '../sidebar';
import SingleProjects from '../../project-detail-view/components/project-detail-view';
import Projects from '../../projects/components/projects';
import Notifications from '../../notifications/components/notifications';
import PendingActions from '../../pending-actions/components/pending-actions';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { isAuthenticated } from '../utils/auth-service';
import React from 'react';
import { authActions } from '../../../redux/auth/slice';
import { profileDataActions } from '../../../redux/profileData/slice';
import ResourceAllocations from '../../resource-allocations/components/resource-allocations';
import SingleResourceAllocations from '../../member-detail-view/components/single-resource-allocations';
import { IPermissions } from '../utils/interfaces';
import Dashboard from '../../dashboard/components/dashboard';
import ToolsAndTechnologies from '../../tools-and-technologies/components/tools-and-technologies';
import Users from '../../users/components/users';

const SidebarLayout = (): JSX.Element => (
  <>
    <Sidebar />
    <Box sx={{ flexGrow: 1 }}>
      <Outlet />
    </Box>
  </>
);

function Router(): JSX.Element {
  const dispatch = useAppDispatch();
  const { profileData } = useAppSelector((state) => state.profileData);
  const [userPermissions, setUserPermissions] = React.useState<IPermissions>();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  const signInLoading = useAppSelector(
    (state) => state.auth.getSignInUrlLoading
  );
  const signOutLoading = useAppSelector(
    (state) => state.auth.getSignOutUrlLoading
  );

  React.useEffect(() => {
    if (!isAuthenticated()) {
      dispatch(authActions.getSignInUrl());
    } else {
      dispatch(profileDataActions.getProfileData());
    }
  }, []);

  React.useEffect(() => {
    if (profileData) {
      if (profileData.permissions) {
        setUserPermissions(profileData.permissions);
        setIsLoading(false);
      }
    }
  }, [profileData]);

  return (
    <BrowserRouter>
      <Box sx={{ display: 'flex' }}>
        <Routes>
          {!signInLoading &&
          !signOutLoading &&
          isAuthenticated() &&
          !isLoading ? (
            <Route element={<SidebarLayout />}>
              <Route path={HOME_ROUTE} element={<Dashboard />} />
              <Route path={DASHBOARD} element={<Dashboard />} />
              {userPermissions?.notification?.read ? (
                <Route path={NOTIFICATIONS} element={<Notifications />} />
              ) : null}
              {userPermissions?.pending_action?.read ? (
                <Route path={PENDING_ACTIONS} element={<PendingActions />} />
              ) : null}
              {userPermissions?.project.read ? (
                <Route path={PROJECTS}>
                  <Route path={ALL_PROJECTS} element={<Projects />} />
                  <Route path={SINGLE_PROJECT} element={<SingleProjects />} />
                </Route>
              ) : null}
              {userPermissions?.resource_allocation?.read ? (
                <Route path={RESOURCE_ALLOCATIONS}>
                  <Route
                    path={ALL_RESOURCE_ALLOCATIONS}
                    element={<ResourceAllocations />}
                  />
                  <Route
                    path={SINGLE_RESOURCE_ALLOCATIONS}
                    element={<SingleResourceAllocations />}
                  />
                </Route>
              ) : null}
              {userPermissions?.tools?.read ? (
                <Route
                  path={TOOLS_AND_TECHNOLOGIES}
                  element={<ToolsAndTechnologies />}
                />
              ) : null}
              {userPermissions?.rolesAndDepartments?.read ? (
                <Route path={USERS} element={<Users />} />
              ) : null}
              <Route path={NOT_FOUND} element={<NotFound />} />
            </Route>
          ) : null}
        </Routes>
      </Box>
    </BrowserRouter>
  );
}

export default Router;
